exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-common-___modal__modal___3-KBJ {\n  background: #fff;\n  max-width: 100%;\n}\n\n.src-components-common-___modal__modal___3-KBJ h4,\n.src-components-common-___modal__modal___3-KBJ h5 {\n  margin-top: 0;\n}\n\n.src-components-common-___modal__footer___dJDve {\n  padding: 14px 14px 14px 24px;\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid #D8D8D8;\n}\n\n.src-components-common-___modal__footer___dJDve button {\n  padding: 0 16px !important;\n}\n\n.src-components-common-___modal__footer___dJDve button.src-components-common-___modal__actionButton___3eMhU {\n  float: none;\n  margin: 0;\n}\n\n.src-components-common-___modal__footer___dJDve button.src-components-common-___modal__actionButton___3eMhU + .src-components-common-___modal__actionButton___3eMhU {\n  margin-left: 14px;\n}\n\n.src-components-common-___modal__footer___dJDve button.src-components-common-___modal__cancelButton___L1_GH {\n  color: #5d8ce3;\n  border: 1px solid #D8D8D8;\n}", ""]);

// exports
exports.locals = {
	"modal": "src-components-common-___modal__modal___3-KBJ",
	"footer": "src-components-common-___modal__footer___dJDve",
	"actionButton": "src-components-common-___modal__actionButton___3eMhU",
	"cancelButton": "src-components-common-___modal__cancelButton___L1_GH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/common/modal.scss
// module id = 1462
// module chunks = 0